/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="86.12"
        height="95.45"
        viewBox="0 0 86.12 95.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.93.32a1.24 1.24 0 0 1 1.67 0C50.81 9.5 62.99 14.05 78.32 14.5a1.25 1.25 0 0 1 1.2 1.12v20a1.25 1.25 0 0 1-1.28 1.22 1.27 1.27 0 0 1-1.22-1.29V16.96h-.27c-14.72-.7-26.71-5.21-36.82-13.89l-.18-.15-.17.15C29.65 11.6 17.89 16.1 3.5 16.91l-1 .05v18c.27 12.74 1.88 22.3 5.8 30.89l.24.52c5.56 11.87 15.43 20.7 30.93 26.42l.25.09.46-.17a68.81 68.81 0 0 0 11.78-5.62l.69-.42a1.24 1.24 0 0 1 1.72.39 1.26 1.26 0 0 1-.39 1.73 71.82 71.82 0 0 1-13.83 6.6 1.37 1.37 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-28C1.7 57.58.05 46.7-.01 31.74v-16a1.25 1.25 0 0 1 1.22-1.24c15.29-.45 27.51-5 37.72-14.18Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M59.31 37.15a1.25 1.25 0 0 1 1.42 1 1.24 1.24 0 0 1-1 1.42 20.79 20.79 0 1 0 6.34 0 1.24 1.24 0 0 1-1-1.42 1.26 1.26 0 0 1 1.43-1 23.27 23.27 0 1 1-7.11 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M51.74 35.2a1.24 1.24 0 0 1 1.51-.7h.12l6.59 2.74a1.25 1.25 0 0 1 .67 1.64 1.23 1.23 0 0 1-1.51.71H59l-6.59-2.74a1.26 1.26 0 0 1-.67-1.65Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M58.5 37.69a1.25 1.25 0 0 1 2.09 1.37l-.08.11-4.29 5.84a1.25 1.25 0 0 1-2.09-1.37l.07-.11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M62.64 44.26a1.24 1.24 0 0 1 1.24 1.12v12.81h12.89a1.26 1.26 0 0 1 1.25 1.12v.13a1.25 1.25 0 0 1-1.12 1.24H62.64a1.25 1.25 0 0 1-1.24-1.13V45.5a1.25 1.25 0 0 1 1.24-1.24Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithClock360ArrowIcon';

export default Icon;
